import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import Home from '../views/Home/Home.vue'
import Login from '../views/Home.vue'
import SignUp from '../views/SignUp.vue'
import ConfirmMail from '../views/ConfirmMail.vue'
import RetrievePass from '../views/RetrievePass.vue'
import SetNewPass from '../views/SetNewPass.vue'
import Portal from '../views/Portal/Portal.vue'
import ActivateCode from '../views/ActivateCode/ActivateCode.vue'
import ObjectCode from '../views/ActivateCode/ObjectCode.vue'
import ConfirmEmailTiers from '../views/ActivateCode/ConfirmEmailTiers.vue'
import GetFiles from '../views/ActivateCode/DownloadFiles.vue'
import Contact from '../views/Contact/Contact.vue'
import Cookies from '../views/Cookies.vue'


const routes: Array<RouteRecordRaw> = [
  {
    path: '/Contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/GetFiles/:id',
    name: 'GetFiles',
    component: GetFiles
  },
  {
    path: '/ConfirmEmailTiers/:id',
    name: 'ConfirmEmailTiers',
    component: ConfirmEmailTiers
  },
  {
    path: '/ObjectCode/:id',
    name: 'ObjectCode',
    component: ObjectCode
  },
  {
    path: '/ActivateCode',
    name: 'ActivateCode',
    component: ActivateCode
  },  
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/SignUp',
    name: 'SignUp',
    component: SignUp
  },
  {
    path: '/ConfirmMail/:id',
    name: 'ConfirmMail',
    component: ConfirmMail
  },
  {
    path: '/RetrievePass',
    name: 'RetrievePass',
    component: RetrievePass
  },
  {
    path: '/SetNewPass/:id',
    name: 'SetNewPass',
    component: SetNewPass
  },
  {
    path: '/Portal',
    name: 'Portal',
    component: Portal
  },
  {
    path: '/Login',
    name: 'Login',
    component: Login
  },
  {
    path: '/Cookies',
    name: 'Cookies',
    component: Cookies
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const privatePages = ['/portal'];
  const authRequired = privatePages.includes(to.path.toLowerCase());
  const loggedIn = localStorage.getItem('user');

  if (authRequired && !loggedIn) {
    return next('/');
  }

  next();
})

export default router
